var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_7934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6144 51.8617C19.753 52.3962 23.3637 54.0769 25.9202 56.3923C26.4556 56.8773 26.2562 58.4211 25.6152 58.7541C22.5544 60.3442 18.6352 61.0526 14.4966 60.5181C10.3579 59.9836 6.7473 58.3029 4.19079 55.9874C3.65536 55.5025 3.85479 53.9587 4.49578 53.6257C7.55656 52.0356 11.4757 51.3272 15.6144 51.8617Z",
    fill: "url(#paint0_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6144 51.8617C19.753 52.3962 23.3637 54.0769 25.9202 56.3923C26.4556 56.8773 26.2562 58.4211 25.6152 58.7541C22.5544 60.3442 18.6352 61.0526 14.4966 60.5181C10.3579 59.9836 6.7473 58.3029 4.19079 55.9874C3.65536 55.5025 3.85479 53.9587 4.49578 53.6257C7.55656 52.0356 11.4757 51.3272 15.6144 51.8617Z",
    fill: "url(#paint1_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0982 46.066C20.5243 47.9849 23.9967 51.0082 26.0951 54.3987C26.5344 55.1087 25.8186 56.7597 25 56.9244C21.091 57.7106 16.5107 57.2424 12.0848 55.3236C7.6587 53.4048 4.18629 50.3816 2.08794 46.991C1.64858 46.281 2.36437 44.6299 3.18296 44.4652C7.09198 43.6792 11.6722 44.1472 16.0982 46.066Z",
    fill: "url(#paint2_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0982 46.066C20.5243 47.9849 23.9967 51.0082 26.0951 54.3987C26.5344 55.1087 25.8186 56.7597 25 56.9244C21.091 57.7106 16.5107 57.2424 12.0848 55.3236C7.6587 53.4048 4.18629 50.3816 2.08794 46.991C1.64858 46.281 2.36437 44.6299 3.18296 44.4652C7.09198 43.6792 11.6722 44.1472 16.0982 46.066Z",
    fill: "url(#paint3_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0678 36.7627C25.8406 41.2492 26.1583 45.8424 25.2445 49.7236C25.0531 50.5364 23.3794 51.1977 22.6842 50.7353C19.3642 48.527 16.4564 44.9573 14.6836 40.4708C12.9109 35.9844 12.5931 31.3911 13.507 27.51C13.6983 26.6972 15.372 26.0359 16.0672 26.4983C19.3872 28.7064 22.295 32.2762 24.0678 36.7627Z",
    fill: "url(#paint4_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0678 36.7627C25.8406 41.2492 26.1583 45.8424 25.2445 49.7236C25.0531 50.5364 23.3794 51.1977 22.6842 50.7353C19.3642 48.527 16.4564 44.9573 14.6836 40.4708C12.9109 35.9844 12.5931 31.3911 13.507 27.51C13.6983 26.6972 15.372 26.0359 16.0672 26.4983C19.3872 28.7064 22.295 32.2762 24.0678 36.7627Z",
    fill: "url(#paint5_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6076 36.9314C22.1205 40.9887 25.0549 45.9824 26.2031 50.8652C26.4436 51.8878 24.9301 53.5714 23.8878 53.4407C18.9107 52.8166 13.634 50.4284 9.12108 46.371C4.60814 42.3137 1.67377 37.32 0.525494 32.4371C0.285024 31.4146 1.79853 29.731 2.84085 29.8617C7.81785 30.4858 13.0946 32.8741 17.6076 36.9314Z",
    fill: "url(#paint6_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59302 37.9854C4.12821 40.9744 6.32045 43.8531 9.12127 46.3712C13.6342 50.4285 18.9108 52.8168 23.888 53.4409C24.9303 53.5716 26.4438 51.8882 26.2033 50.8655C25.0551 45.9826 22.1207 40.9889 17.6077 36.9316C14.9504 34.5425 12.0279 32.7327 9.058 31.5205L2.59302 37.9854Z",
    fill: "url(#paint7_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3856 51.8617C51.247 52.3962 47.6363 54.0769 45.0798 56.3923C44.5444 56.8773 44.7438 58.4211 45.3848 58.7541C48.4456 60.3442 52.3648 61.0526 56.5034 60.5181C60.6421 59.9836 64.2527 58.3029 66.8092 55.9874C67.3446 55.5025 67.1452 53.9587 66.5042 53.6257C63.4434 52.0356 59.5243 51.3272 55.3856 51.8617Z",
    fill: "url(#paint8_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3856 51.8617C51.247 52.3962 47.6363 54.0769 45.0798 56.3923C44.5444 56.8773 44.7438 58.4211 45.3848 58.7541C48.4456 60.3442 52.3648 61.0526 56.5034 60.5181C60.6421 59.9836 64.2527 58.3029 66.8092 55.9874C67.3446 55.5025 67.1452 53.9587 66.5042 53.6257C63.4434 52.0356 59.5243 51.3272 55.3856 51.8617Z",
    fill: "url(#paint9_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9018 46.066C50.4757 47.9849 47.0033 51.0082 44.905 54.3987C44.4656 55.1087 45.1814 56.7597 46 56.9244C49.909 57.7106 54.4893 57.2424 58.9152 55.3236C63.3413 53.4048 66.8137 50.3816 68.9121 46.991C69.3514 46.281 68.6356 44.6299 67.8171 44.4652C63.908 43.6792 59.3278 44.1472 54.9018 46.066Z",
    fill: "url(#paint10_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9018 46.066C50.4757 47.9849 47.0033 51.0082 44.905 54.3987C44.4656 55.1087 45.1814 56.7597 46 56.9244C49.909 57.7106 54.4893 57.2424 58.9152 55.3236C63.3413 53.4048 66.8137 50.3816 68.9121 46.991C69.3514 46.281 68.6356 44.6299 67.8171 44.4652C63.908 43.6792 59.3278 44.1472 54.9018 46.066Z",
    fill: "url(#paint11_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9322 36.7627C45.1594 41.2492 44.8417 45.8424 45.7555 49.7236C45.9468 50.5364 47.6205 51.1977 48.3157 50.7353C51.6358 48.527 54.5435 44.9573 56.3163 40.4708C58.0891 35.9844 58.4068 31.3911 57.493 27.51C57.3017 26.6972 55.628 26.0359 54.9328 26.4983C51.6127 28.7064 48.705 32.2762 46.9322 36.7627Z",
    fill: "url(#paint12_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9322 36.7627C45.1594 41.2492 44.8417 45.8424 45.7555 49.7236C45.9468 50.5364 47.6205 51.1977 48.3157 50.7353C51.6358 48.527 54.5435 44.9573 56.3163 40.4708C58.0891 35.9844 58.4068 31.3911 57.493 27.51C57.3017 26.6972 55.628 26.0359 54.9328 26.4983C51.6127 28.7064 48.705 32.2762 46.9322 36.7627Z",
    fill: "url(#paint13_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3923 36.9314C48.8794 40.9887 45.945 45.9824 44.7967 50.8652C44.5563 51.8878 46.0698 53.5714 47.1121 53.4407C52.0892 52.8166 57.3659 50.4284 61.8788 46.371C66.3917 42.3137 69.3261 37.32 70.4744 32.4371C70.7149 31.4146 69.2013 29.731 68.159 29.8617C63.182 30.4858 57.9053 32.8741 53.3923 36.9314Z",
    fill: "url(#paint14_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4069 37.9854C66.8717 40.9744 64.6795 43.8531 61.8787 46.3712C57.3657 50.4285 52.0891 52.8168 47.112 53.4409C46.0697 53.5716 44.5561 51.8882 44.7966 50.8655C45.9449 45.9826 48.8793 40.9889 53.3922 36.9316C56.0496 34.5425 58.972 32.7327 61.9419 31.5205L68.4069 37.9854Z",
    fill: "url(#paint15_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 69.9999C47.5547 69.9999 57.3271 60.2276 57.3271 48.1728C57.3271 36.118 47.5547 26.3457 35.5 26.3457C23.4452 26.3457 13.6729 36.118 13.6729 48.1728C13.6729 60.2276 23.4452 69.9999 35.5 69.9999Z",
    fill: "url(#paint16_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 65.5704C45.1084 65.5704 52.8977 57.7812 52.8977 48.1726C52.8977 38.5641 45.1084 30.7749 35.4999 30.7749C25.8914 30.7749 18.1022 38.5641 18.1022 48.1726C18.1022 57.7812 25.8914 65.5704 35.4999 65.5704Z",
    fill: "url(#paint17_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 63.109C43.7489 63.109 50.436 56.4219 50.436 48.1729C50.436 39.9239 43.7489 33.2368 35.4999 33.2368C27.251 33.2368 20.5638 39.9239 20.5638 48.1729C20.5638 56.4219 27.251 63.109 35.4999 63.109Z",
    fill: "url(#paint18_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6729 48.1728C13.6729 60.2276 23.4451 69.9999 35.5 69.9999C47.5548 69.9999 57.3271 60.2276 57.3271 48.1728C57.3271 48.0881 57.3249 48.004 57.3239 47.9194H13.676C13.675 48.004 13.6729 48.0881 13.6729 48.1728Z",
    fill: "url(#paint19_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6216 69.1285C48.4993 67.1227 53.9722 61.8239 56.2195 55.0527L45.5887 44.4219L43.1921 44.5396L36.7238 38.0713L28.8406 56.3475L41.6216 69.1285Z",
    fill: "url(#paint20_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4501 43.4302L40.1695 42.396C39.7713 42.2998 39.4234 42.0584 39.1937 41.7191L36.7262 38.0715C36.4276 37.6304 35.9704 37.3936 35.4999 37.3555C35.0294 37.3936 34.5721 37.6304 34.2737 38.0715L31.8061 41.7191C31.5766 42.0584 31.2287 42.2998 30.8304 42.396L26.5498 43.4302C25.3886 43.7108 24.9048 45.0966 25.6389 46.039L28.3454 49.513C28.5971 49.8362 28.7193 50.2416 28.6877 50.6501L28.3485 55.0408C28.2566 56.2317 29.425 57.1203 30.5482 56.7132L34.6885 55.2127C34.9501 55.1179 35.2291 55.0935 35.4999 55.1355C35.7709 55.0936 36.0498 55.118 36.3114 55.2127L40.4517 56.7132C41.5747 57.1202 42.7433 56.2317 42.6513 55.0408L42.3122 50.6501C42.2806 50.2416 42.4028 49.8362 42.6545 49.513L45.361 46.039C46.0951 45.0966 45.6112 43.7108 44.4501 43.4302Z",
    fill: "url(#paint21_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3114 55.2127L40.4517 56.7132C41.5748 57.1202 42.7434 56.2317 42.6514 55.0408L42.3122 50.6501C42.2807 50.2416 42.4028 49.8362 42.6546 49.513L45.3611 46.039C46.0953 45.0968 45.6113 43.7108 44.4501 43.4302L40.1695 42.396C39.7714 42.2998 39.4234 42.0584 39.1938 41.7191L36.7262 38.0715C36.4277 37.6304 35.9705 37.3936 35.5 37.3555V55.1355C35.7709 55.0935 36.05 55.1179 36.3114 55.2127Z",
    fill: "url(#paint22_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.45 43.4303L40.1694 42.396C40.0233 42.3608 39.8841 42.3055 39.7549 42.2334L28.8429 56.3477C29.271 56.7614 29.9168 56.9422 30.5482 56.7134L34.6884 55.2129C34.9501 55.1181 35.2291 55.0936 35.4999 55.1356C35.7708 55.0938 36.0497 55.1182 36.3113 55.2129L40.4516 56.7134C41.5747 57.1203 42.7432 56.2319 42.6513 55.0409L42.3121 50.6503C42.2806 50.2418 42.4027 49.8364 42.6544 49.5131L45.361 46.0392C46.095 45.0967 45.6112 43.7108 44.45 43.4303Z",
    fill: "url(#paint23_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5498 43.4303L30.8304 42.396C30.9766 42.3608 31.1157 42.3055 31.2449 42.2334L42.1569 56.3477C41.7288 56.7614 41.0831 56.9422 40.4517 56.7134L36.3114 55.2129C36.0498 55.1181 35.7707 55.0936 35.4999 55.1356C35.229 55.0938 34.9501 55.1182 34.6885 55.2129L30.5482 56.7134C29.4252 57.1203 28.2566 56.2319 28.3485 55.0409L28.6877 50.6503C28.7193 50.2418 28.5971 49.8364 28.3454 49.5131L25.6389 46.0392C24.9048 45.0967 25.3886 43.7108 26.5498 43.4303Z",
    fill: "url(#paint24_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4104 44.4224C25.2069 44.9357 25.2558 45.5474 25.6388 46.0392L28.3454 49.5131C28.5971 49.8364 28.7193 50.2418 28.6877 50.6503L28.3485 55.041C28.2566 56.2319 29.425 57.1205 30.5482 56.7134L34.6885 55.2129C34.9501 55.1181 35.2291 55.0937 35.4999 55.1357C35.7709 55.0938 36.0498 55.1182 36.3114 55.2129L40.4517 56.7134C41.5747 57.1204 42.7433 56.2319 42.6513 55.041L42.3122 50.6503C42.2946 50.4237 42.326 50.1985 42.399 49.9872L25.4104 44.4224Z",
    fill: "url(#paint25_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5911 44.4224C45.7946 44.9357 45.7459 45.5474 45.3627 46.0392L42.6561 49.5131C42.4044 49.8364 42.2823 50.2418 42.3138 50.6503L42.653 55.041C42.7449 56.2319 41.5763 57.1205 40.4533 56.7134L36.313 55.2129C36.0514 55.1181 35.7724 55.0937 35.5016 55.1357C35.2306 55.0938 34.9517 55.1182 34.6901 55.2129L30.5498 56.7134C29.4268 57.1204 28.2582 56.2319 28.3502 55.041L28.6893 50.6503C28.7069 50.4237 28.6755 50.1985 28.6025 49.9872L45.5911 44.4224Z",
    fill: "url(#paint26_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 26.3457C35.4093 26.3457 35.3194 26.348 35.2291 26.3491L31.8606 29.7176L56.4513 54.3084C57.0204 52.3618 57.327 50.3031 57.327 48.1727C57.327 36.118 47.5547 26.3457 35.4999 26.3457Z",
    fill: "url(#paint27_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3234 0.45752V11.9869L35.4998 25.1634L48.6763 11.9869V0.45752H22.3234Z",
    fill: "url(#paint28_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3234 0.45752V4.04564L35.4558 17.178C35.4801 17.2023 35.5196 17.2023 35.5439 17.178L48.6763 4.04564V0.45752H22.3234Z",
    fill: "url(#paint29_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3234 0.45752V4.04564L35.4558 17.178C35.4801 17.2023 35.5196 17.2023 35.5439 17.178L48.6763 4.04564V0.45752H22.3234Z",
    fill: "url(#paint30_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4998 19.254C34.9566 19.254 34.4135 19.0473 34.0001 18.6337L22.3234 6.95703V11.9869L35.4998 25.1633L48.6763 11.9869V6.95703L36.9996 18.6337C36.5862 19.0471 36.0431 19.254 35.4998 19.254Z",
    fill: "url(#paint31_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4998 19.254C34.9566 19.254 34.4135 19.0473 34.0001 18.6337L22.3234 6.95703V11.9869L35.4998 25.1633L48.6763 11.9869V6.95703L36.9996 18.6337C36.5862 19.0471 36.0431 19.254 35.4998 19.254Z",
    fill: "url(#paint32_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4998 19.254C36.0431 19.254 36.5862 19.0473 36.9996 18.6337L48.6763 6.95703V11.9869L35.4998 25.1633L22.3234 11.9869V6.95703L34.0001 18.6337C34.4135 19.0471 34.9567 19.254 35.4998 19.254Z",
    fill: "url(#paint33_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.055 22.1702L22.8421 10.9573C22.0013 10.1165 20.6379 10.1165 19.7971 10.9573C18.9563 11.7981 18.9563 13.1615 19.7971 14.0023L35.4999 29.7053L51.2028 14.0024C52.0437 13.1616 52.0437 11.7982 51.2028 10.9574C50.362 10.1166 48.9987 10.1166 48.1578 10.9574L36.9449 22.1703C36.1468 22.9683 34.853 22.9683 34.055 22.1702Z",
    fill: "url(#paint34_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.797 10.9828L33.8466 25.0324C34.7597 25.9455 36.2403 25.9455 37.1535 25.0324L51.2029 10.9828C51.207 10.9787 51.2103 10.9742 51.2144 10.97C51.2104 10.9659 51.207 10.9614 51.2029 10.9573C50.3621 10.1165 48.9987 10.1165 48.1579 10.9573L36.945 22.1702C36.147 22.9682 34.8531 22.9682 34.0551 22.1702L22.8422 10.9573C22.0014 10.1165 20.638 10.1165 19.7972 10.9573C19.7931 10.9614 19.7898 10.9659 19.7856 10.97C19.7896 10.9742 19.7929 10.9787 19.797 10.9828Z",
    fill: "url(#paint35_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 29.7052L46.5844 18.6206H40.4943L36.9448 22.1702C36.1468 22.9682 34.8528 22.9682 34.0548 22.1702L30.5053 18.6206H24.4152L35.4999 29.7052Z",
    fill: "url(#paint36_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1273 28.3329L35.4999 29.7054L49.5583 15.647H43.4682L36.9449 22.1703C36.1701 22.9451 34.9294 22.9653 34.1273 22.2358V28.3329Z",
    fill: "url(#paint37_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4998 31.2252C38.3423 31.2252 40.6466 28.9209 40.6466 26.0784C40.6466 23.2359 38.3423 20.9316 35.4998 20.9316C32.6573 20.9316 30.353 23.2359 30.353 26.0784C30.353 28.9209 32.6573 31.2252 35.4998 31.2252Z",
    fill: "url(#paint38_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4998 29.0293C37.1294 29.0293 38.4505 27.7083 38.4505 26.0786C38.4505 24.449 37.1294 23.1279 35.4998 23.1279C33.8701 23.1279 32.5491 24.449 32.5491 26.0786C32.5491 27.7083 33.8701 29.0293 35.4998 29.0293Z",
    fill: "url(#paint39_linear_4466_7934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6668 5.12414H20.3329C19.4613 5.12414 18.7548 4.41755 18.7548 3.54598V1.57816C18.7548 0.706588 19.4613 0 20.3329 0H50.6669C51.5384 0 52.245 0.706588 52.245 1.57816V3.54612C52.245 4.41769 51.5384 5.12414 50.6668 5.12414Z",
    fill: "url(#paint40_linear_4466_7934)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4466_7934",
    x1: 10.4813,
    y1: 49.8832,
    x2: 15.0107,
    y2: 56.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4466_7934",
    x1: 10.0689,
    y1: 53.8884,
    x2: 17.2061,
    y2: 57.1825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4466_7934",
    x1: 5.83541,
    y1: 44.5597,
    x2: 13.3158,
    y2: 50.1185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4466_7934",
    x1: 8.97141,
    y1: 50.7775,
    x2: 14.6446,
    y2: 50.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4466_7934",
    x1: 20.8636,
    y1: 31.7726,
    x2: 19.1479,
    y2: 39.6647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4466_7934",
    x1: 13.4499,
    y1: 32.5674,
    x2: 17.842,
    y2: 37.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4466_7934",
    x1: 10.8117,
    y1: 33.6682,
    x2: 14.5862,
    y2: 45.4721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4466_7934",
    x1: 11.5722,
    y1: 40.0959,
    x2: 16.4219,
    y2: 44.3051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4466_7934",
    x1: 60.5185,
    y1: 49.8832,
    x2: 55.9891,
    y2: 56.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4466_7934",
    x1: 60.9311,
    y1: 53.8884,
    x2: 53.7939,
    y2: 57.1825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4466_7934",
    x1: 65.1646,
    y1: 44.5597,
    x2: 57.6842,
    y2: 50.1185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4466_7934",
    x1: 62.0286,
    y1: 50.7775,
    x2: 56.3554,
    y2: 50.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4466_7934",
    x1: 50.1364,
    y1: 31.7726,
    x2: 51.8521,
    y2: 39.6647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4466_7934",
    x1: 57.5501,
    y1: 32.5674,
    x2: 53.1579,
    y2: 37.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4466_7934",
    x1: 60.1882,
    y1: 33.6682,
    x2: 56.4137,
    y2: 45.4721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4466_7934",
    x1: 59.4277,
    y1: 40.0959,
    x2: 54.5781,
    y2: 44.3051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4466_7934",
    x1: 22.0427,
    y1: 34.7155,
    x2: 45.0625,
    y2: 57.7354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4466_7934",
    x1: 46.7996,
    y1: 59.4723,
    x2: 23.8706,
    y2: 36.5433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4466_7934",
    x1: 24.6418,
    y1: 37.3148,
    x2: 42.5147,
    y2: 55.1877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4466_7934",
    x1: 35.5,
    y1: 54.559,
    x2: 35.5,
    y2: 68.8857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4466_7934",
    x1: 48.5725,
    y1: 59.5165,
    x2: 30.5462,
    y2: 48.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4466_7934",
    x1: 30.9532,
    y1: 44.0243,
    x2: 39.1523,
    y2: 52.2232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4466_7934",
    x1: 40.4128,
    y1: 46.2597,
    x2: 29.0806,
    y2: 50.9445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4466_7934",
    x1: 37.4539,
    y1: 50.2813,
    x2: 31.2497,
    y2: 47.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4466_7934",
    x1: 33.546,
    y1: 50.2813,
    x2: 39.7502,
    y2: 47.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4466_7934",
    x1: 33.6839,
    y1: 50.5927,
    x2: 37.6723,
    y2: 44.1827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4466_7934",
    x1: 37.0102,
    y1: 49.7831,
    x2: 36.6779,
    y2: 43.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4466_7934",
    x1: 46.2558,
    y1: 38.9517,
    x2: 37.8375,
    y2: 24.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4466_7934",
    x1: 36.476,
    y1: 7.77911,
    x2: 41.8976,
    y2: 16.4262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4466_7934",
    x1: 31.0683,
    y1: -2.83015,
    x2: 47.9049,
    y2: 16.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4466_7934",
    x1: 35.4998,
    y1: 9.1275,
    x2: 35.4998,
    y2: 4.59342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4466_7934",
    x1: 27.4917,
    y1: 0.288639,
    x2: 44.3282,
    y2: 19.5957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4466_7934",
    x1: 40.7148,
    y1: 14.6868,
    x2: 43.0578,
    y2: 17.0298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4466_7934",
    x1: 30.2848,
    y1: 14.6868,
    x2: 27.9419,
    y2: 17.0298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4466_7934",
    x1: 47.398,
    y1: 24.3779,
    x2: 19.2525,
    y2: -3.76757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4466_7934",
    x1: 35.5,
    y1: 11.209,
    x2: 35.5,
    y2: 30.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4466_7934",
    x1: 35.4999,
    y1: 22.3722,
    x2: 35.4999,
    y2: 28.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4466_7934",
    x1: 41.9875,
    y1: 18.7941,
    x2: 38.1444,
    y2: 22.7059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4466_7934",
    x1: 32.5488,
    y1: 23.1274,
    x2: 39.8275,
    y2: 30.4061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4466_7934",
    x1: 38.3821,
    y1: 28.961,
    x2: 31.5637,
    y2: 22.1426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4466_7934",
    x1: 35.4999,
    y1: 1.55551,
    x2: 35.4999,
    y2: 4.41563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_7934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/gold-medal.07dcdd00f6c1b99f19440b4f0e36f8f3.svg";
export { ForwardRef as ReactComponent };